const LearnMoreBtn = ({ topStyle, leftStyle }) => {
  let learnMoreBtnStyle = {
    position: "absolute",
    left: leftStyle,
    top: topStyle,
    transform: "translate(-50%, -50%)",
    border: "1px solid black",
    padding: "8px",
    transition: "2s all",
  };

  return (
    <span className="learn_more" style={learnMoreBtnStyle}>
      learn more
    </span>
  );
};

export default LearnMoreBtn;
